"use client";

import { useEffect } from "react";
import Link from "next/link";
import WhimstayContainerNew from "components/utilities/WhimstayContainerNew";
import { makeCDNUrl } from "utils/url";
const ErrorContent = ({
  errorDetail,
  sentry_error_id
}: {
  errorDetail: string;
  sentry_error_id: string;
}) => {
  useEffect(() => {
    void (async () => {
      const {
        mixpanelV2Client
      } = await import("services/mixpanelv2");
      const path = typeof window !== "undefined" ? window.location.href : "NA";
      mixpanelV2Client.WEBSITE_ERROR({
        pageType: "500",
        path,
        errorDetail,
        sentry_error_id
      });
    })();
  }, [errorDetail, sentry_error_id]);
  return <WhimstayContainerNew className='my-16 text-center' data-sentry-element="WhimstayContainerNew" data-sentry-component="ErrorContent" data-sentry-source-file="ErrorContent.tsx">
      <div className='mx-auto max-w-[490px]'>
        <p className='mb-3 bg-white text-lg font-medium uppercase text-secondary500'>
          500 Internal Server Error
        </p>
        <h2 className='mb-3 bg-white text-[2.5rem] font-semibold leading-10 text-secondary500'>
          Oops!
        </h2>
        <p className='bg-white pb-2.5 text-grayText'>
          We are sorry! There was an error.
        </p>
        <div className='relative mx-auto h-0 w-full pb-[79%]'>
          <img src={makeCDNUrl("/assets/images/Cabin-Deck.png")} alt='page-not-found' className='absolute bottom-0 left-0 right-0 top-0 h-full w-full ' />
        </div>
        <div className='mt-5 flex flex-col items-center justify-center gap-2 bg-white'>
          <p className='text-center text-grayText'>
            {`Not to worry, why don't you try one of these helpful links:`}
          </p>
          <Link href='/' className='bg-white text-xl font-semibold text-secondary500' data-sentry-element="Link" data-sentry-source-file="ErrorContent.tsx">
            HOME
          </Link>
          <Link href='/' className='bg-white text-xl font-semibold text-secondary500' data-sentry-element="Link" data-sentry-source-file="ErrorContent.tsx">
            SEARCH
          </Link>
          <Link href='/contact-us' className='bg-white text-xl font-semibold text-secondary500' data-sentry-element="Link" data-sentry-source-file="ErrorContent.tsx">
            HELP
          </Link>
        </div>
      </div>
    </WhimstayContainerNew>;
};
export default ErrorContent;